import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_chevron_top = _resolveComponent("icon-chevron-top")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["scroll-top", { 'is-active': $setup.isVisible }]),
    onClick: _withModifiers($setup.scrollTop, ["prevent"])
  }, [
    _createVNode(_component_icon_chevron_top)
  ], 2))
}